import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createBlock(_component_BaseButton, {
    label: "Cancel",
    color: "light-black",
    "background-color": "light-gray",
    "icon-padding-bottom": 1,
    "border-color": "dark-gray",
    "border-width": 2,
    width: 80,
    height: 28,
    "padding-horizontal": 12,
    enabled: _ctx.enabled,
    "on-click": _ctx.onClick
  }, null, 8, ["enabled", "on-click"]))
}